import React, { useState } from 'react'
export const Toggle = ({
  label,
  toggled,
  onClick,
  className,
  isPartner,
  hasMarginTop = true,
  hasMarginLeft = true,
}) => {
  const [isToggled, toggle] = useState(toggled)

  const callback = () => {
    toggle(!isToggled)
    onClick(!isToggled)
  }

  return (
    <div
      className={
        isPartner
          ? `toggleSwitch ${hasMarginTop ? 'mt5px' : ''} `
          : `toggleSwitch ${hasMarginTop ? 'mt5px' : ''} ${
              hasMarginLeft ? 'ml18' : ''
            }`
      }
    >
      <label>
        <input type='checkbox' checked={toggled} onChange={callback} />
        <span />
      </label>
      {label && <a className={`${className || ''}`}>{label}</a>}
    </div>
  )
}
